export const PUBLIC_PRIVATE = '[GENERAL] PUBLIC_PRIVATE'
export const OPEN_REGISTER_MODAL = '[GENERAL] OPEN_REGISTER_MODAL'
